import React from "react";
import { Check } from "lucide-react";

export default function Stepper({ steps, current, onStepClick }) {
  return (
    <nav aria-label="Progress" className="mb-8" data-testid="wizard-stepper">
      <ol className="flex items-center w-full gap-1 sm:gap-2">
        {steps.map((label, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <li key={i} className="flex-1 flex items-center min-w-0">
              <button
                type="button"
                onClick={() => onStepClick && i <= current && onStepClick(i)}
                data-testid={`step-tab-${i}`}
                className="flex flex-col items-center gap-1.5 w-full group focus:outline-none"
              >
                <div className="flex items-center w-full">
                  <span
                    className={`grid place-items-center h-9 w-9 rounded-full border-2 text-sm font-semibold transition-colors shrink-0 mx-auto
                      ${done ? "bg-emerald-600 border-emerald-600 text-white" : active ? "bg-[#8B1E2B] border-[#8B1E2B] text-white" : "bg-white border-amber-300 text-amber-700"}`}
                  >
                    {done ? <Check className="h-4 w-4" /> : i + 1}
                  </span>
                </div>
                <span className={`text-[11px] sm:text-xs text-center leading-tight truncate w-full px-1 ${active ? "text-[#8B1E2B] font-semibold" : "text-slate-500"}`}>
                  {label}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
